// Maps a route to its checkout flow entry_point. These are the only routes a
// session is expected to enter the funnel through; every other funnel route is
// reached after one of these has already opened (hydrated) the flow.
//
// Used to attribute order.flow.started. The router registers a resolver over
// this map into the tracking module (see registerEntryPointResolver), so the
// funnel-integrity fallback stays correctly attributed instead of generic.
const ENTRY_POINT_BY_ROUTE_NAME = Object.freeze({
  order: 'order',
  'order.papi': 'papi_transit',
  'order-recovery': 'recovery',
  'nft.order': 'nft_order',
  'nft.order.transit': 'nft_transit',
});

export const resolveCheckoutEntryPoint = (route) => ENTRY_POINT_BY_ROUTE_NAME[route?.name] ?? null;

export default resolveCheckoutEntryPoint;
